import type { ReactNode, MouseEvent } from 'react';

import { SWReactIcons } from '@similarweb/icons';
import { colorsPalettes } from '@similarweb/styles';

import { StyledToggleButton, StyledToggleIconWrapper } from './styles';

export type ToggleButtonProps = {
  children: ReactNode;
  onClick?(event: MouseEvent<HTMLButtonElement>): void;
  className?: string;
  disabled?: boolean;
  isSelected?: boolean;
  'data-automation'?: string;
};

export const ToggleButton = (props: ToggleButtonProps) => {
  const { onClick, className, disabled, isSelected = false, children } = props;
  return (
    <StyledToggleButton
      onClick={onClick}
      className={className}
      disabled={disabled}
      isSelected={isSelected}
      data-automation={props['data-automation']}
    >
      <StyledToggleIconWrapper isSelected={isSelected}>
        {isSelected ? <SWReactIcons iconName="checked" iconColor={colorsPalettes.blue[400]} size="9px" /> : null}
      </StyledToggleIconWrapper>
      {children}
    </StyledToggleButton>
  );
};
